export default "__VITE_ASSET__81e9bd08__"